import {
  Card, CardContent, Box, Typography, Button, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, Avatar,
  AvatarGroup, Skeleton
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

const SkeletonRow = () => (
  <TableRow>
    {[100, 150, 80, 200].map((w, i) => (
      <TableCell key={i}>
        {i === 0 ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton width={w} />
          </Box>
        ) : (
          <Skeleton width={w} />
        )}
      </TableCell>
    ))}
  </TableRow>
);

const CollaborationRow = ({ collab, history }) => (
  <TableRow hover>
    <TableCell>
      <Box
        onClick={() => history.push('/artist-profile', { data: collab, status: '', page: 'artist' })}
        sx={{ display: "flex", alignItems: "center", gap: 2, cursor: "pointer" }}
      >
        <AvatarGroup max={3} sx={{ justifyContent: "flex-start" }}>
          <Avatar src={collab.avatar_url} alt={collab.name} sx={{ width: 32, height: 32 }} />
        </AvatarGroup>
        {collab.name}
      </Box>
    </TableCell>
    <TableCell><Typography fontWeight="bold">{collab.email}</Typography></TableCell>
    <TableCell>{collab.primary_category}</TableCell>
    <TableCell>{collab.about}</TableCell>
  </TableRow>
);

export const CollaborationsSection = ({ collaborations, loading }) => {
  const history = useHistory();

  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          {loading ? (
            <>
              <Skeleton width={150} height={32} />
              <Skeleton width={200} height={36} sx={{ borderRadius: 2 }} />
            </>
          ) : (
            <>
              <Typography variant="h5" fontWeight="bold">Collaborations</Typography>
              <Button
                variant="outlined"
                className="gn-actionbtn"
                startIcon={<Add />}
                sx={{ borderRadius: 2 }}
                onClick={() => history.push('/collaboration/categories')}
              >
                Collaboration
              </Button>
            </>
          )}
        </Box>

        <TableContainer component={Paper} sx={{ boxShadow: "none", border: 1, borderColor: "divider" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Category</TableCell>
                <TableCell>About</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: 3 }).map((_, i) => <SkeletonRow key={i} />)
              ) : collaborations.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography variant="h6" color="text.secondary">No collaborations found</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Request collaborations to expand your network
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                collaborations.map((collab) => (
                  <CollaborationRow key={collab.id} collab={collab} history={history} />
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
